<template>
    <div class="dml-main-categories" data-t="22">
        <nav class="dml-main-categories__tabs" data-t="22.1">
            <a v-for="(category, index) in categories"
               :href="genders[index].link"
               class="dml-categories-tab"
               :key="index"
               v-bind:class="isCategoryActive(index)"
               v-on:click.prevent="handleTabChange(index)"
               data-ga="m_home.click_category_tab"
               :data-ga-label="genders[index].name"
               :data-t="`22.1.${index + 1}`">
                <span class="dml-categories-tab__text">
                    {{genders[index].name}}
                </span>
            </a>
        </nav>
        <div class="dml-main-categories__content">
            <div class="dml-main-categories__label">
                <div class="dml-main-categories__label-text">
                    <span class="_twb">POPULARNE</span> KATEGORIE
                </div>
            </div>
            <ul class="dml-main-categories__group dml-main-categories__group--active">
                <component v-for="(tiles, index) in categories[currentCategoryGroup]"
                           v-bind:is="tiles.component"
                           :tiles="tiles"
                           :key="index" />
            </ul>
        </div>
    </div>
</template>
<script>
    import VerticalTile from './vertical-tile-component';
    import TwoTiles from './two-tiles-component';
    import TwoTilesAndHorizontal from './two-tiles-and-horizontal-component';
    import HorizontalTileAndTwo from './horizontal-tile-and-two-component';

    export default {
        name: 'dml-categories',
        components: {
            'dm-vertical-tile': VerticalTile,
            'dm-two-tiles': TwoTiles,
            'dm-two-tiles-and-horizontal': TwoTilesAndHorizontal,
            'dm-horizontal-tile-and-two': HorizontalTileAndTwo,
        },
        props: {
            categories: {
                type: Array,
                required: true
            },
            genders: {
                type: Object,
                required: true
            },
            currentCategoryGroup: {
                type: Number,
                default: 0
            }
        },
        methods: {
            handleTabChange(gender) {
                this.$emit('changeTab', gender);
            },
            isCategoryActive(index) {
                return this.currentCategoryGroup === index ? 'dml-categories-tab--active' : '';
            },
        }
    };
</script>
